import { useState } from "react"

import { toast } from "@/components/toast"
import { analytics } from "@/lib/analytics"
import { api } from "@/lib/api"
import { normalizeSiteUrl } from "./markdown-import/utils/site-url"

export function useSiteImport({
	portalInstanceId = null,
	onStarted,
}: { portalInstanceId?: string | null; onStarted?: () => void } = {}) {
	const [url, setUrl] = useState("")
	const [error, setError] = useState<string | null>(null)
	const context = api.useUtils()
	const startImport = api.workspace.startHelpCenterSiteImport.useMutation()

	const run = async () => {
		const target = normalizeSiteUrl(url)
		if (!target) {
			setError("Enter the address of your help center.")
			return
		}

		try {
			await startImport.mutateAsync({ url: target, portalInstanceId })
		} catch (cause) {
			setError(
				cause instanceof Error
					? cause.message
					: "Couldn't read that help center. Try again.",
			)
			return
		}

		analytics.track("import-articles-from-site")
		await context.workspace.helpCenterSiteImportStatus.invalidate()
		setUrl("")
		toast.success({
			title: "Reading your help center",
			description:
				"We read it in the background. The articles show up in Docs as they come.",
		})
		onStarted?.()
	}

	return {
		url,
		error,
		isLoading: startImport.isLoading,
		run,
		change: (value: string) => {
			setUrl(value)
			setError(null)
		},
	}
}
